import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8fs23t2a: FaireBrandEntity = {
  token: "b_8fs23t2a",
  type: "brand",
  name: "Gigi and Max",
  avatarUrl:
    "https://cdn.faire.com/fastly/5b75dd073cad01dea5f03485d0da4f9c7e930ade01f5ddcee5e9ade31f66102a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8023fde69819e586d9a53a8a921e57a56a4eab4e2575be5b9ff355c040ab907f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5b75dd073cad01dea5f03485d0da4f9c7e930ade01f5ddcee5e9ade31f66102a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8023fde69819e586d9a53a8a921e57a56a4eab4e2575be5b9ff355c040ab907f.png",
  location: "IA, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 178,
  isTopShop: true,
  isInsider: true,
  description:
    "Gigi and Max - softest bamboo clothing for your baby and toddler! Our beautiful floral prints are exclusive and sell out fast! Created by a Mom, our bamboo clothing is perfectly functional and made to last.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:26.307Z",
    importedBy: "entity-db-cli",
  },
};
